var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commission-manage"},[_c('div',{staticClass:"nav-bar"},_vm._l((_vm.barList),function(item,index){return _c('div',{key:index,staticClass:"nav-item",class:{
         on: item.routerName == _vm.$route.name
       },on:{"click":function($event){return _vm.navHandle(item)}}},[_vm._v(_vm._s(item.label))])}),0),_c('div',{staticClass:"report-home-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }